import React from 'react';
import PropTypes from 'prop-types';
import {
  InputText,
  Radio,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
} from '../../../Shared';

import {
  inputTheme,
  inputThemeShort,
  radioTheme,
} from '../../../lib';


const formName = 'Pre-Inked Stamps';

const defaultValues = {
  'Quantity': '',
  'Size': '',
  'Colour': '',
  'Graphics': '',
  'Refill-ink': '',
};

const fields = [
  'Quantity',
  'Size',
  'Colour',
  'Graphics',
  'Refill-ink',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />

      <InputText
        inputTextId='Colour'
        inputTextName='Colour'
        register={register}
        formState={formState}
        label='Colour'
        theme={inputTheme}
      />

      <Radio
        radioId='Graphics'
        radioName='Graphics'
        legend='Graphics?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

      <Radio
        radioId='Refill-ink'
        radioName='Refill-ink'
        legend='Do you require refill ink?'
        options={[
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ]}
        register={register}
        formState={formState}
        columns={2}
        theme={radioTheme}
      />

    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
